import React from 'react'
import Select, { ActionMeta, OnChangeValue, StylesConfig, components, DropdownIndicatorProps, GroupBase } from 'react-select';


import { OptionTypes } from '../../types/types';
import { FormikContextType } from 'formik';

interface SelectProp {
  heightControlSection?: string,
  isSearchable?: boolean,
  disabled?:boolean
  options: OptionTypes[],
  borderColor?: string,
  setOptionSelected?: (option: OptionTypes) => void,
  setSelectSearch?: (input: string) => void,
  isLoading?: boolean
  formik?: FormikContextType<any>
  fieldName: string
  placeholder?: string
  className?: string
  value?: OptionTypes | null | string
  isClearable?: boolean,
  onChange?: (option: OptionTypes) => void
}


const SelectComponent = (p: SelectProp) => {
  
  const customStyles = {

    dropdownIndicator: (base, state) => ({
      ...base,
      color: 'var(--primary)',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      cursor: 'pointer',
      opacity: p.disabled ? 0 : 1,
      '&:hover': {
        color: 'var(--primary)'
      }
    }),

    control: (baseStyles, state) => ({
      ...baseStyles,
      
      color: "var(--black)",
      boxShadow: 'none',
      backgroundColor: state.isFocused ? "white !important" : "white",
      border: state.isFocused ? '1px solid black' : `${p.borderColor ? p.borderColor : '1px solid black'}`,
      cursor: 'text',
      width: "100%",
      fontWeight: "400",
      fontSize: "16px",
      borderRadius: "3px",
      position: "relative",
      lineHeight: "22px",
      height: `${p.heightControlSection}`,


      "&:hover": {
        color: "var(--black)"
      },
    }),

    menu: (baseStyles, state) => ({
      ...baseStyles,
      width: '100%',
      position: 'absolute',
      border: '1px solid var(--black)',
      borderRadius: '3px'
    }),

    menuList: (provided) => ({
      ...provided,
      maxHeight: "250px"
    }),

    input: (provided, state) => ({
      ...provided,
    }),

    container: (provided, state) => ({
      ...provided,
      border: "none",
      opacity: p.disabled ? 0.3 : 1
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      // paddingTop: "15px",
      // paddingBottom: "15px",
    }),

    option: (provided, state) => {
      const optionStyle = {
        ...provided,
        lineHeight: '22px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        backgroundColor: state.isSelected ? "var(--primary)" : "white",
        cursor: "pointer",
        borderRadius: '3px',
        // height: '9vh',
        // fontWeight: '800',

        "&:hover": {
          backgroundColor: "var(--primary)",
          color: state.isSelected ? "black" : "white"
        },

        ":active": {
          backgroundColor: "var(--primary)",
          color: 'black'
        }
      }
      return optionStyle
    },

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
      return { ...provided, opacity, transition };
    }

  } as StylesConfig;

  return (
    <Select
      {...p.formik?.getFieldProps(p.fieldName)}
      name={p.fieldName}
      options={p.options}
      captureMenuScroll={true}
      placeholder={p.placeholder}
      isDisabled={p.disabled}
      styles={customStyles}
      isSearchable={p.isSearchable ? true : false}
      components={{ IndicatorSeparator: () => null }}
      onChange={(option) => {p.formik?.setFieldValue(p.fieldName, option); p.setOptionSelected?.(option as OptionTypes)}}
      onBlur={() => p.formik?.setFieldTouched(p.fieldName, true)}
      isClearable={p.isClearable ? true : false}
      isLoading={p.isLoading}
      onInputChange={(input) => p.setSelectSearch?.(input as string)}
      className={p.className ?? ""}
      value={p.value}
    />
  )

  // sintassi componente
  // const [selectedOption, setSelectedOption] = useState<OptionTypes>({ id: '', value: '', label: '' })
  //  const [selectSearch, setSelectSearch] = useState('')
  //const debounceSelectSearch = useDebounce(selectSearch, 1000)
  // const [isLoading, setIsLoading] = useState(false)
  // <SelectComponent isLoading={isLoading} setSelectSearch={setSelectSearch} setOptionSelected={setSelectedOption} options={[{ id: 'dsacd', value: 'dsavdsav', label: 'dsavdsav' }]} borderColor={'1px solid var(--primary)'} isSearchable></SelectComponent>
}

export default SelectComponent
